export default __webpack_public_path__ + "static/media/BackScreen.60ab23cc.png";